<template>
    <modal
        name="como-anadir-productos"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
        id="como-anadir-productos"
        :adaptive="true"
        :classes="'custom-modal'"
    >
        <div class="card m-4">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2 class="text-dark" style="cursor: pointer;">{{ $t('productos.comoAnadirTitulo') }}</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div style="font-size: 18px; line-height: 1.6;">
                    <!-- Normativa -->
                    <h3 style="font-size: 24px; font-weight: bold;">{{ $t('productos.comoAnadirContenido.normativa') }}</h3>

                    <!-- Selecciona tu producto extra -->
                    <h4 style="font-size: 20px; font-weight: bold; margin-top: 20px;">{{ $t('productos.comoAnadirContenido.seleccionaProducto') }}</h4>
                    <p v-if="manager.tipo === 2">{{ $t('productos.comoAnadirContenido.seleccionaProductoDescripcion_teatro') }}</p>
                    <p v-else>{{ $t('productos.comoAnadirContenido.seleccionaProductoDescripcion') }}</p>

                    <!-- Recepción del ticket -->
                    <h4 style="font-size: 20px; font-weight: bold; margin-top: 20px;">{{ $t('productos.comoAnadirContenido.recepcionTicket') }}</h4>
                    <p>{{ $t('productos.comoAnadirContenido.recepcionTicketDescripcion') }}</p>

                    <!-- Condiciones de compra -->
                    <h4 style="font-size: 20px; font-weight: bold; margin-top: 20px;">{{ $t('productos.comoAnadirContenido.condicionesCompra') }}</h4>
                    <ul style="padding-left: 20px;">
                        <li v-for="(condicion, index) in $t('productos.comoAnadirContenido.condicionesCompraDescripcion')" :key="index">
                            {{ condicion }}
                        </li>
                    </ul>

                    <!-- Mensaje final -->
                    <p style="font-size: 18px; margin-top: 20px;">
                        {{ $t('productos.comoAnadirContenido.disfruta') }}
                    </p>
                </div>
            </div>
            <div class="card-footer text-right">
                <Button type="button" name="button" @click.prevent="close()">{{$t('partido.continuar')}}</Button>
            </div>
        </div>
    </modal>
</template>

<script>
    export default {
        methods: {
            close() {
                this.$modal.hide('como-anadir-productos');
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
        },
    };
</script>

<style scoped>
/* Hacer el fondo alrededor del modal transparente */
.custom-modal {
    background-color: rgba(0, 0, 0, 0.6) !important; /* Fondo negro transparente */
    padding: 0;
}

/* Ajustes de la tarjeta para que mantenga su diseño */
.card {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.card-header {
    background-color: #f1f1f1;
}

.card-footer {
    background-color: #f9f9f9;
}
</style>
